<template>
  <mobile-responsive-shell :title="title">
    <div class="mobile-embed-sale-form">
      <desktop-view />
    </div>
  </mobile-responsive-shell>
</template>

<script>
import MobileResponsiveShell from "../../components/MobileResponsiveShell.vue";
import DesktopView from "@/views/sales/items/Create.vue";

export default {
  name: "MobileSalesItemsCreate",
  components: {
    MobileResponsiveShell,
    DesktopView,
  },
  data() {
    return {
      title: "Article vente",
    };
  },
};
</script>

<style scoped>
.mobile-embed-sale-form ::v-deep .row {
  margin-left: 0;
  margin-right: 0;
}
.mobile-embed-sale-form ::v-deep [class*="col-"] {
  flex: 0 0 100%;
  max-width: 100%;
  width: 100%;
}
.mobile-embed-sale-form ::v-deep .table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
